module.exports = __webpack_public_path__ + "9c8ad21ac481241abaddeb8f66b159ad.svg";